export class AddPresenceRequest {

    _date = undefined;
    _constructionId = undefined;
    _workerIds = [];

    constructor(date, constructionId) {
        this._date = date.toISOFirstTime();
        this._constructionId = constructionId;
    }

    setPresences(_workerIds) {
        this._workerIds = _workerIds;
    }

    data() {
        return {
            date: this._date,
            construction_id: this._constructionId,
            worker_ids: this._workerIds,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/webservices/add-presence/AddPresenceRequest.js